var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1084 24.8057C30.477 23.916 30.6667 22.9624 30.6667 21.9993C30.6667 20.0544 29.894 18.1892 28.5188 16.8139C27.1435 15.4386 25.2783 14.666 23.3333 14.666C21.3884 14.666 19.5231 15.4386 18.1479 16.8139C16.7726 18.1892 16 20.0544 16 21.9993C16 22.9624 16.1897 23.916 16.5582 24.8057C16.9268 25.6954 17.4669 26.5038 18.1479 27.1848C18.8288 27.8658 19.6373 28.4059 20.527 28.7745C21.4167 29.143 22.3703 29.3327 23.3333 29.3327C24.2964 29.3327 25.25 29.143 26.1397 28.7745C27.0294 28.4059 27.8378 27.8658 28.5188 27.1848C29.1997 26.5038 29.7399 25.6954 30.1084 24.8057Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 18.9438C22.0446 18.9438 21 19.6399 21 20.4993C21 21.3588 22.0446 22.0549 23.3333 22.0549C24.6221 22.0549 25.6667 22.751 25.6667 23.6105C25.6667 24.4699 24.6221 25.166 23.3333 25.166M23.3333 18.9438C24.1967 18.9438 24.9511 19.2565 25.3548 19.7216M23.3333 18.9438V18.166M23.3333 25.166C22.47 25.166 21.7156 24.8533 21.3119 24.3882M23.3333 25.166V25.9438",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 6.66732C21.3332 9.61284 18.9454 12.0007 15.9998 12.0007C13.0543 12.0007 10.6665 9.61284 10.6665 6.66732C10.6665 3.7218 13.0543 1.33398 15.9998 1.33398C18.9454 1.33398 21.3332 3.7218 21.3332 6.66732Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 15.334C13.3174 15.334 12.6491 15.3948 11.9998 15.5114C6.69448 16.4639 2.6665 21.1389 2.6665 26.7626V28.6673H11.9998",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetGrowth);
export default __webpack_public_path__ + "static/media/assetGrowth.9f0e56b035fe1e07c68f3bc66e124faf.svg";
export { ForwardRef as ReactComponent };